import { render, staticRenderFns } from "./CorporateClients.vue?vue&type=template&id=0edbe014&"
import script from "./CorporateClients.vue?vue&type=script&lang=ts&"
export * from "./CorporateClients.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports